// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3h-fe","modalForm":"UpgradeEpcsModal_modalForm__3G7ME","modalFooter":"UpgradeEpcsModal_modalFooter__3rtEM"};